import { useState } from 'react';

import { Alert, AlertDescription } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

interface EmailEntryFormProps {
  onSubmit: (email: string) => void;
  defaultEmail?: string;
  isLoading?: boolean;
  error?: string | null;
}

export function EmailEntryForm({ onSubmit, defaultEmail, isLoading, error }: EmailEntryFormProps) {
  const [email, setEmail] = useState(defaultEmail || '');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email.trim()) {
      onSubmit(email.trim());
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div className="space-y-2">
        <Label htmlFor="email" className="text-sm font-medium text-neutral-950">
          Email
        </Label>
        <Input
          id="email"
          type="email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          required
          disabled={isLoading}
          className="h-11 border-neutral-200 focus:ring-black focus:border-black text-neutral-950"
          placeholder="you@example.com"
        />
      </div>

      {error && (
        <Alert variant="destructive">
          <AlertDescription>{error}</AlertDescription>
        </Alert>
      )}

      <Button
        type="submit"
        disabled={isLoading || !email.trim()}
        className="w-full h-11 bg-black hover:bg-gray-800 text-white font-medium"
      >
        {isLoading ? 'Checking...' : 'Continue'}
      </Button>
    </form>
  );
}
